import React from "react";

const ReserveIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.781 9.83722C18.0553 10.1528 18.0218 10.631 17.7062 10.9052L13.6374 14.4412C13.1694 14.8479 12.458 14.7882 12.0643 14.3091L10.4651 12.3629C10.1997 12.0399 10.2464 11.5628 10.5694 11.2974C10.8924 11.032 11.3695 11.0786 11.6349 11.4017L12.9646 13.0199L16.713 9.76239C17.0286 9.48813 17.5068 9.52164 17.781 9.83722Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.584164 15.735L4.05463 5.68216L5.48583 6.17624L2.01536 16.2291C1.84563 16.7208 2.21084 17.2332 2.73096 17.2332H6.95533V18.7473H2.73096C1.17059 18.7473 0.0749786 17.21 0.584164 15.735Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2413 5.97343L5.83298 5.96384C5.59422 5.96024 5.41182 6.17589 5.45498 6.41074L7.52302 17.6629C7.55604 17.8426 7.71264 17.973 7.8953 17.973H22.481C22.7204 17.973 22.8997 17.7536 22.8519 17.519L20.6065 6.27643C20.5711 6.10219 20.4191 5.97612 20.2413 5.97343ZM5.85583 4.44993C4.66206 4.43191 3.75002 5.51019 3.96584 6.68443L6.03388 17.9366C6.19897 18.8349 6.982 19.4871 7.8953 19.4871H22.481C23.6779 19.4871 24.5743 18.39 24.3356 17.2171L22.0902 5.97452C21.9129 5.10331 21.1531 4.47294 20.2642 4.45952L5.85583 4.44993Z"
      fill="white"
    />
  </svg>
);

export default ReserveIcon;
